import { EventTemplate, GeneralPayload, HandlerLookup } from "../eventUtil";
import { ProjectState } from "../projectState";

enum UtilityEventType {
  Unknown = "utility/unknown",
}

interface UnknownEvent extends EventTemplate {
  eventType: UtilityEventType.Unknown;
  payload: GeneralPayload;
}

type UtilityEvent = UnknownEvent;

const utilityHandlers: HandlerLookup<UtilityEvent> = {
  [UtilityEventType.Unknown]: {
    generalizer: ({ payload }: UnknownEvent): GeneralPayload => payload,
    specifier: (payload: GeneralPayload): UnknownEvent => ({
      eventType: UtilityEventType.Unknown,
      payload,
    }),
    reducer: (state: ProjectState, action: UnknownEvent) => state,
    validator: () => true,
  },
};

export type { UtilityEvent };
export { utilityHandlers, UtilityEventType };
